export default __webpack_public_path__ + "static/media/calendar-initial-icon.b3902b9b.svg";